module.exports = __webpack_public_path__ + "static/media/default.6af2039c.png";